import * as Sentry from '@sentry/nextjs'

export const reportError = (exception, context) =>
  Sentry.captureException(exception, context)

export const reportMessage = (exception, severity) =>
  Sentry.captureMessage(exception, severity)
